import { render, staticRenderFns } from "./BaseProjectList.vue?vue&type=template&id=00c4f190&scoped=true&"
import script from "./BaseProjectList.vue?vue&type=script&lang=js&"
export * from "./BaseProjectList.vue?vue&type=script&lang=js&"
import style0 from "./BaseProjectList.vue?vue&type=style&index=0&id=00c4f190&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4f190",
  null
  
)

export default component.exports